var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconIp48Line = function SvgIconIp48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.3C14.79 7.3 7.3 14.79 7.3 24c0 9.21 7.49 16.7 16.7 16.7 9.21 0 16.7-7.49 16.7-16.7 0-9.21-7.49-16.7-16.7-16.7Zm0 30c-7.33 0-13.3-5.97-13.3-13.3 0-7.33 5.97-13.3 13.3-13.3 7.33 0 13.3 5.97 13.3 13.3 0 7.33-5.97 13.3-13.3 13.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 16h-3.51v16h3.51V16ZM28 16h-5.31v16h3.63v-4.37h1.69c3.21 0 5.81-2.61 5.81-5.81 0-3.2-2.61-5.81-5.81-5.81L28 16Zm0 8h-1.69v-4.37H28a2.19 2.19 0 1 1 0 4.38V24Z",
    fill: "current"
  })));
};
export default SvgIconIp48Line;